import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7A7B1",
      d: "M12.751 2.505A7.5 7.5 0 1 1 1.505 9.243L1.5 9l.004-.243A7.5 7.5 0 0 1 12.75 2.505M9.001 4.5a.75.75 0 0 0-.745.662l-.005.088V9l.007.098a.75.75 0 0 0 .147.358l.066.075 2.25 2.25.07.061a.75.75 0 0 0 .92 0l.07-.062.063-.07a.75.75 0 0 0 0-.92l-.063-.07-2.03-2.031v-3.44l-.005-.087A.75.75 0 0 0 9 4.5",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }